
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Marketing - mirrors the Partnership template surface: a single gdoc_embed
// widget hosting the per-supplier copy of the Marketing intake template doc.
// Same shape as Partnership / Onboarding - the per-supplier copy is created
// at provision time and its URL is written into the gdoc_embed.
export function Marketing(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
